import * as React from 'react';

// COMPONENTS
import RequestsToJoinItem from './RequestsToJoinItem';
import Button from '../../components/Button';

// ICONS
import { ReactComponent as PlusIcon } from '../../assets/svg/plus.svg';

// TYPES
interface RequestsToJoinItemListTypes {
	role?: string;
	peopleList?: {
		id?: string;
		firstName?: string;
		lastName?: string;
		image?: string;
		organisationRole?: string[];
		timeRequested?: string;
	}[];
}
import { ExtraDomainProfileType } from '../../Interfaces';
import { DomainProfileType } from '../../api/models';

const RequestsToJoinItemList: React.FC<RequestsToJoinItemListTypes> = ({ role, peopleList }) => {
	const [maxItem, setMaxItem] = React.useState<number>(5);

	const displayRoleName = (role: string) => {
		if (role === DomainProfileType.Staff) {
			return <>Staff or Volunteer</>;
		} else if (role === DomainProfileType.Visitor) {
			return <>Visitor</>;
		} else if (role === DomainProfileType.Parent) {
			return <>Parent or Parent Volunteer</>;
		} else if (role === ExtraDomainProfileType.ParentVolunteer) {
			return <>Parent Volunteer</>;
		} else if (role === DomainProfileType.Student) {
			return <>Child or Student</>;
		} else return role;
	};

	if (peopleList !== undefined) {
		return (
			<section className="role-list-section">
				<div className="role-list-section-name requests-to-join-page">
					{displayRoleName(role || '')}
					<span className="quantity">{peopleList?.length}</span>
				</div>

				{peopleList?.slice(0, maxItem).map((people) => {
					const { id, firstName, lastName, image, timeRequested } = people;

					return (
						<RequestsToJoinItem
							key={id}
							image={image}
							firstName={firstName}
							lastName={lastName}
							id={id}
							timeRequested={timeRequested}
							role={role || ''}
						/>
					);
				})}

				{maxItem < peopleList.length && (
					<Button
						buttonIcon={<PlusIcon className="link-icon" />}
						className="btn-secondary btn-show-more"
						type="button"
						onClick={() => setMaxItem(peopleList.length)}
					>
						Show {peopleList.length - maxItem} more
					</Button>
				)}
			</section>
		);
	} else {
		return null;
	}
};

export default RequestsToJoinItemList;
